import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SignupPageComponent } from './components/signup-page/signup-page.component';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { GetStartedPageComponent } from './components/get-started-page/get-started-page.component';
import { ForgotPageComponent } from './components/forgot-page/forgot-page.component';
import { ResetPasswordPageComponent } from './components/reset-password-page/reset-password-page.component';
import { VerifyEmailPageComponent } from './components/verify-email-page/verify-email-page.component';
import { VerifyEmailSuccessPageComponent } from './components/verify-email-success-page/verify-email-success-page.component';
import { HeaderComponent } from './components/shared/header/header.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { SharePostComponent } from './components/shared/share-post/share-post.component';
import { CommentPostComponent } from './components/shared/comment-post/comment-post.component';
import { HomePageComponent } from './modules/home-page/home-page.component';
import { MessagesPageComponent } from './modules/messages-page/messages-page.component';
import { ChannelsPageComponent } from './modules/channels-page/channels-page.component';
import { DefaultComponent } from './default/default.component';
import { StoriesComponent } from './components/shared/stories/stories.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NoChannelPageComponent } from './modules/channels/no-channel-page/no-channel-page.component';
import { CreateChannelComponent } from './modules/channels/create-channel/create-channel.component';
import { ActivityPostComponent } from './components/shared/activity-post/activity-post.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { SubcriptionComponent } from './modules/channels/subscription/subscription.component';
import { StroyComponent } from './modules/story/stroy/stroy.component';
import { StroyLiveComponent } from './modules/story/stroy-live/stroy-live.component';
import { StroyCameraComponent } from './modules/story/stroy-camera/stroy-camera.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { NgxGlideModule } from 'ngx-glide';
import { NotificationsComponent } from './modules/notifications/notifications.component';
import { ProfilePageComponent } from './modules/profile/profile.component';
import { EditProfileComponent } from './components/shared/edit-profile/edit-profile.component';
import { ProfileMediaComponent } from './components/shared/profile-media/profile-media.component';
import { MycontactsComponent } from './components/shared/mycontacts/mycontacts.component';
import { ViewProfileComponent } from './components/shared/view-profile/view-profile.component';
import { SettingsComponent } from './modules/settings/settings.component';
import { NotificationsSettingsComponent } from './components/shared/notifications-settings/notifications-settings.component';
import { PrivacyComponent } from './components/shared/privacy/privacy.component';
import { LanguageComponent } from './components/shared/language/language.component';
import { HelpComponent } from './components/shared/help/help.component';
import { UpgradeSubscriptionComponent } from './components/shared/upgrade-subcription/upgrade-subcription.component';
import { AudioCallComponent } from './modules/calling/audio-call/audio-call.component';
import { VideoCallComponent } from './modules/calling/video-call/video-call.component';
import { GroupCallComponent } from './modules/calling/group-call/group-call.component';
import { ScreenShareComponent } from './modules/calling/screen-share/screen-share.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CollapseModule } from 'ngx-bootstrap/collapse';
// import { FormsModule } from '@angular/forms';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};


@NgModule({
  declarations: [
    AppComponent,
    SignupPageComponent,
    LoginPageComponent,
    GetStartedPageComponent,
    ForgotPageComponent,
    ResetPasswordPageComponent,
    VerifyEmailPageComponent,
    VerifyEmailSuccessPageComponent,
    HeaderComponent,
    FooterComponent,
    SharePostComponent,
    CommentPostComponent,
    HomePageComponent,
    MessagesPageComponent,
    ChannelsPageComponent,
    DefaultComponent,
    StoriesComponent,
    NoChannelPageComponent,
    CreateChannelComponent,
    SubcriptionComponent,
    ActivityPostComponent,
    StroyComponent,
    StroyLiveComponent,
    StroyCameraComponent,
    NotificationsComponent,
    ProfilePageComponent,
    EditProfileComponent,
    ProfileMediaComponent,
    MycontactsComponent,
    ViewProfileComponent,
    SettingsComponent,
    NotificationsSettingsComponent,
    PrivacyComponent,
    LanguageComponent,
    HelpComponent,
    UpgradeSubscriptionComponent,
    AudioCallComponent,
    VideoCallComponent,
    GroupCallComponent,
    ScreenShareComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SwiperModule,
    NgxGlideModule,
    // FormsModule,
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    AccordionModule.forRoot(),
    BsDropdownModule.forRoot(),
    CollapseModule.forRoot(),
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
